module.exports = __webpack_public_path__ + "img/ausstellung5.30f33c04.jpg";